<template>
    <div class="kiaf-persion-setting" v-loading="loading">
        <kc-form label-width="5rem">
            <h3 v-if="!forceUpdatePwd">修改密码<i class="kedaIconfont KD-baocun keda-icon-heavy-style" title="保存"
                                              @click="savePwd"></i></h3>
            <kc-form-item label="旧密码">
                <kc-input type="password" v-model="oldPwd" auto-complete="off" name="passText"
                          class="is-hidden"></kc-input>
                <kc-input type="password" v-model="oldPwd" auto-complete="off" class="old-pwd">
                    <template #suffix>
                        <i @click.stop="handleClearPassword('oldPwd')" class="kc-icon-error"></i>
                    </template>
                </kc-input>
            </kc-form-item>
            <kc-form-item label="新密码">
                <kc-input type="password" v-model="newPwd" class="new-pwd">
                    <template #suffix>
                        <i @click.stop="handleClearPassword('newPwd')" class="kc-icon-error"></i>
                    </template>
                </kc-input>
            </kc-form-item>
            <kc-form-item label="密码确认">
                <kc-input type="password" v-model="repeatPwd" class="new-pwd2">
                    <template #suffix>
                        <i @click.stop="handleClearPassword('repeatPwd')" class="kc-icon-error"></i>
                    </template>
                </kc-input>
            </kc-form-item>
        </kc-form>
        <slot name="personalSettingMiddleForm"></slot>
        <kc-form label-width="5rem" v-if="!staticHomePage">
            <h3 class="content-bottom-title">修改主页<i title="保存" @click="saveHomePage"
                                                    class="kedaIconfont KD-baocun keda-icon-heavy-style"></i></h3>
            <kc-form-item label="业务主页">
                <div @click="businessClick()" class="homepage">
                    <kc-input v-model="business" :readonly="true">
                        <i slot="suffix" @click.stop="handleClear()" class="kc-icon-error"></i>
                    </kc-input>
                </div>
            </kc-form-item>
        </kc-form>
        <kc-modal
                width="16.2rem"
                v-if="menuDialog"
                :title=this.typesName
                :visible.sync="menuDialog"
                v-model="menuDialog"
                :fullscreen-bg="true"
                append-to-body
                class="business-homepage">
            <div class="tree m-scroll">
                <kc-tree
                        :load="loadNode"
                        v-if="treedata && treedata.length>0"
                        :data="treedata"
                        :props="keymap"
                        :styles="styles"
                        @node-click="handleChange">
                </kc-tree>
            </div>
        </kc-modal>
    </div>
</template>
<script>
    import Auth from '../../../utils/auth';
    import Global from '../../../utils/global';
    import Util from '../../../utils/util';
    import {changePasswordApi, updateHomePage} from '../../service/person.js';
    import {logoutApi, getHomePage} from '../../service/login.js';

    export default {
        name: 'KiafPersonSetting',
        props: {
            forceUpdatePwd: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                menuDialog: false,
                typesName: '',
                updateuser: Auth.getUserInfo(),
                oldPwd: '',
                newPwd: '',
                loading: false,
                repeatPwd: '',
                business: '',
                username: '',
                password: '',
                homePageParams: {
                    businessHomepage: '',
                    businessHomepageUrl: ''
                },
                treedata: [],
                keymap: {
                    children: 'children',
                    label: 'name',
                    isLeaf: 'leaf'
                },
                styles: {
                    icon: {
                        color: '#FFA70B',
                        folder: 'wenjianjia'
                    }
                }
            };
        },
        computed: {
            staticHomePage() {
                return Global.isStaticHomePage() || this.forceUpdatePwd;
            }
        },
        mounted() {
            this.password = this.updateuser.password;
            this.username = this.updateuser.username;
            this.$el.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        },
        created() {
            this.init();
            console.log('person setting created>>>>');
        },
        methods: {
            loadNode(node, resolve) {
                console.log(node, '树');
                if (node.level === 0) {
                    return resolve(node.data.map(item => {
                        if (!item.children || item.children.length === 0) {  // 如果没有子菜单则当前菜单为叶子节点
                            return {...item, leaf: true};  // leaf为true时表示叶子节点
                        } else {
                            return {...item};
                        }
                    }));
                } else {
                    return resolve(node.data.children.map(item => {
                        if (!item.children || item.children.length === 0) {
                            if (item.url) {
                                return {...item, leaf: true};
                            }
                        } else {
                            let flag = true;
                            if (item.children && item.children.length > 0) {
                                item.children.forEach(obj => {  // 如果当前菜单的子菜单都没有子菜单或者都没有url，则设为叶子节点
                                    if (obj.children || obj.url) {
                                        flag = false;
                                    }
                                });
                                if (flag && item.url) {
                                    return {...item, leaf: true};
                                } else {
                                    return {...item};
                                }
                            } else {
                                return {...item, leaf: true};
                            }
                        }
                    }));
                }
            },
            handleChange(data) {
                console.log(data, '///////////');
                if (data.url) {
                    this.homePageParams.businessHomepageUrl = data.url;
                    this.homePageParams.businessHomepage = data.name;
                    this.business = data.name;
                    this.menuDialog = false;
                }
            },
            saveHomePage() {
                let pass = true;
                let message = '确定要修改主页么？';
                if (Util.isEmpty(this.business)) {
                    if (!Util.isEmpty(this.homePageParams.businessHomepageUrl)) { //原来不为空，现在清空
                        message = '确定要清空主页么？';
                    } else {
                        pass = false;// 原来就是空的
                    }
                    this.homePageParams.businessHomepageUrl = '';
                    this.homePageParams.businessHomepage = '';
                }
                if (pass) {
                    this.$confirm(message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.loading = true;
                        updateHomePage(this.homePageParams).then(response => {
                            this.loading = false;
                            if (response.status === 200 || response.businessHomepageUrl == this.homePageParams.businessHomepageUrl) {
                                this.$alert('主页设置成功！', '提示', {
                                    confirmButtonText: '确定',
                                    callback: () => {
                                    }
                                });
                            }
                        });
                    });
                } else {
                    this.$alert('请选择主页！', '提示', {
                        confirmButtonText: '确定'
                    });
                }
            },
            async init() {
                if (!this.staticHomePage) {
                    this.loading = true;
                    let homePage = await getHomePage();
                    if (homePage && homePage.businessHomepageUrl) {
                        // 如果主页存在就设置主页
                        this.homePageParams.businessHomepageUrl = homePage.businessHomepageUrl;
                        this.homePageParams.businessHomepage = homePage.businessHomepage;
                        this.business = homePage.businessHomepage;
                    }
                    this.loading = false;
                }
            },
            // 更改当前用户密码
            savePwd() {
                if (this.oldPwd === '') {
                    this.$alert('请输入旧密码', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.newPwd === '') {
                    this.$alert('新密码不能为空！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.newPwd !== this.repeatPwd) {
                    this.$alert('两次新密码输入不一致！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.newPwd == this.oldPwd) {
                    this.$alert('新密码不可以与旧密码相同！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return false;
                }
                let params = {
                    oldPassword: this.oldPwd,
                    password: this.newPwd
                };
                if (Global.getCustomConfig()['KIAF_PASSWORD_TYPE']) {
                    params.type = Global.getCustomConfig()['KIAF_PASSWORD_TYPE'];
                }
                this.$confirm('确定要修改密码么？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    changePasswordApi(params).then(result => {
                        console.log('result>>>>>>>>>', result);
                        let msn = result.message || result[0].message;
                        this.loading = false;
                        if (!msn) {
                            let msg = '密码更新成功';
                            if (this.forceUpdatePwd) {
                                msg = '密码更新成功, 请重新登录';
                            }
                            this.$alert(msg, '提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: () => {
                                    this.logOut();
                                }
                            });
                            this.oldPwd = '';
                            this.newPwd = '';
                            this.repeatPwd = '';
                        } else { //原密码输错或密码不符合要求
                            this.$alert(msn, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });
                            this.oldPwd = '';
                            this.newPwd = '';
                            this.repeatPwd = '';
                        }
                    });
                });
            },
            // window.location.hrefK
            backOperation() {
                this.menuDialog = false;
                this.business = '';
            },
            dialogConfirm() {
                this.menuDialog = false;
            },
            handleClear() {
                this.business = '';
            },
            // 业务主页弹出层
            businessClick: function () {
                this.typesName = '业务主页';
                this.menuDialog = true;
                this.treedata = Global.getMenuList();
            },
            // 退出登录
            logOut() {
                if (this.forceUpdatePwd) {
                    this.$emit('pwdUpdated', {success: true});
                } else {
                    this.$confirm('确定要退出应用吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        logoutApi().then(res => {
                        });
                        setTimeout(() => { //不管Api有没有请求成功，300毫秒后自动清除jwtoken退出
                            Auth.offline();
                            Auth.exit();
                        }, 300);
                    });
                }
            },

            // 清除密码
            handleClearPassword(tag) {
                switch (tag) {
                    case 'oldPwd':
                        this.oldPwd = '';
                        break;

                    case 'newPwd':
                        this.newPwd = '';
                        break;

                    case 'repeatPwd':
                        this.repeatPwd = '';
                        break;
                }
            }
        }
    };
</script>
<style lang="scss">
    @import "index.scss";
</style>
